<template>
    <div v-if="!sessionRemoved" ref="revokeSessionEmailBlock" class="row">
        <div class="col-sm-12 mb-3" >
            <div class="d-flex flex-column gap-3 text-center align-items-center">
	            <i class="bi w-auto h-auto fs-large bi-shield-fill-minus"></i>
                <h3 class="fw-semi-bold m-0">Revoke Access</h3>
                <p class="text-secondary m-0">Are you sure you want to revoke access for this session.</p>
	            <p class="text-secondary m-0">Trusted Device status will be removed and you will be logged out and will need to login again.</p>
            </div>
        </div>

        <div class="col-12">
            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center ">
                <button class="btn btn-outline-secondary rounded-pill py-2 px-3" @click="close">Cancel</button>
                <button class="btn btn-dark rounded-pill py-2 px-3" @click="revokeSessionEmail">Yes, Revoke Access</button>
            </div>
        </div>
    </div>
	<div v-else>
		<div class="d-flex flex-column gap-3 text-center align-items-center">
			<i class="bi w-auto h-auto fs-large bi-shield-fill-minus"></i>
			<h3 class="fw-semi-bold m-0">Access Revoked</h3>
			<p class="text-secondary m-0">Access has been revoked for the selected session.</p>
			<router-link to="/" class="btn btn-dark rounded-pill py-2 px-3">Go to Homepage</router-link>
		</div>
	</div>

</template>

<script setup>
import { watch, ref } from "vue";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";
import { useToast } from "@/composables/useToast.js";
import apiClient from "@/utils/axios.js";
import { useHttpErrorManager } from "@/composables/useHttpErrorManager.js";

const emits = defineEmits(['closeRevokeSessionEmail']);

const props = defineProps({
	data: Object
});

const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();

const revokeSessionEmailBlock = ref(null);

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

const sessionRemoved = ref(false);

const revokeSessionEmail = async () => {
	try{
		helper.loaderOn(revokeSessionEmailBlock.value);
		const response = await apiClient.post('/auth/user/remove-session/revoke/'+props.data.uid+'/'+props.data.session_id, {
			uid: props.data.uid
		});

		if(response.status >= 200 && response.status < 300){
			sessionRemoved.value = true;
		}
		helper.loaderOff(revokeSessionEmailBlock.value);
	}
	catch (error) {
		await useHttpErrorManager().handleError(error, true);
		helper.loaderOff(revokeSessionEmailBlock.value);
	}
}

</script>
